import React, { FC, useState } from 'react';
import { Switch } from '../shared/switch/switch';
import { INITIAL_QUANTITY, MAX_QUANTITY, QUANTITY_STEP } from '../../constants';
import { FormData, InfoAlert } from '../../types';
import { FormattedNumberInput } from '../shared/formatted-number-input/formatted-number-input';
import './header.css';

type Props = {
  setFormData: (formData: FormData) => void;
  formData: FormData;
}

export const Header: FC<Props> = ({
  setFormData,
  formData,
}) => {
  const [infoAlert, setInfoAlert] = useState<InfoAlert | null>(null);
  const onChange = (value: number) => {
    setFormData({ ...formData, quantity: value });
  };

  const barcodeToggle = () => {
    setFormData({ ...formData, barcode: formData.barcode ? 0 : 1 });
  };

  return (
    <div className="header">
      <div className="header-item">
        <div className="header-item-title">
          <span>Количество шт.</span>
        </div>
        <div className="header-item-body">
          <FormattedNumberInput
            onChange={onChange}
            min={INITIAL_QUANTITY}
            max={MAX_QUANTITY}
            step={QUANTITY_STEP}
            value={formData.quantity}
            setInfoAlert={setInfoAlert}
          />
        </div>
      </div>
      <div className="header-item">
        <div className="header-item-title">
          <span>Штрих код</span>
        </div>
        <div className="header-item-body">
          <Switch
            onChange={barcodeToggle} checked={!!formData.barcode}
            text={`${!!formData.barcode ? 'Да' : 'Нет'}`}
          />
        </div>
      </div>

      {infoAlert === InfoAlert.MIN && (
        <p className="info-alert">Минимальное количество от 10 000 шт.</p>
      )}
      {infoAlert === InfoAlert.MAX && (
        <p className="info-alert">Максимальное количество до 59 000 шт.</p>
      )}
    </div>
  );
};